import { SalutationEnum } from '@models/common.model';

// ENUMS #############################################################
// API enums *********************************************************
// UI enums *********************************************************


// INTERFACES ########################################################
// API interfaces ****************************************************
// UI interfaces *****************************************************


// TYPES #############################################################
export type NaturalPersonProp = ( keyof NaturalPerson );
export type NaturalPersonProps = NaturalPersonProp[];

// ENTITIES ##########################################################
// MODEL USED FOR TRANSITION APP<->API (TransitionalModelObject)
export class NaturalPersonTMO {
	public birthDate: Date = undefined;
	public firstName: string = undefined;
	public lastName: string = undefined;
	public nameAffix?: string = undefined;
	public namePrefix?: string = undefined;
	public salutation: SalutationEnum = undefined;
	public title?: string = undefined;
}

// MODEL USED IN APPLICATION (with additional properties)
export class NaturalPerson extends NaturalPersonTMO {}
